<template>
	<div class="answer-cnt">
		<ja-card
			v-for="answer in answers"
			:key="answer.lifestyle_Question_Option_ID"
			:selected="isAnswerSelected(answer.lifestyle_Question_Option_ID)"
			:aria-checked="
				isAnswerSelected(answer.lifestyle_Question_Option_ID).toString()
			"
			role="switch"
			@click.native="selectAnswer(answer)"
		>
			<span>{{ answer.text }}</span>
			<ja-multiselect-circle
				tabindex="-1"
				aria-hidden="true"
				:selected="isAnswerSelected(answer.lifestyle_Question_Option_ID)"
			></ja-multiselect-circle>
		</ja-card>
	</div>
</template>
<script>
import Card from '@/components/ui/Card';
import MultiselectCircle from '@/components/ui/MultiselectCircle';

export default {
	components: {
		jaCard: Card,
		jaMultiselectCircle: MultiselectCircle
	},
	props: {
		answers: {
			type: Array,
			default: () => {
				return [];
			}
		},
		selectedAnswer: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	methods: {
		isAnswerSelected(answer) {
			return !!this.selectedAnswer && this.selectedAnswer.includes(answer);
		},

		selectAnswer(answer) {
			this.$emit('answerSelected', {
				answer: answer.lifestyle_Question_Option_ID,
				text: answer.text
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.answer-cnt {
	display: flex;
	flex-direction: column;
	width: 100%;

	&::v-deep .multi-select-circle {
		float: right;
	}

	:hover {
		::v-deep .multi-select-circle {
			svg {
				fill: $icon-hover;
			}
		}
	}
}
</style>
